module.exports = __webpack_public_path__ + "img/1.eefbf74f.jpg";